
export const transform = ({
							  main,
							  recovery,
							  id,
							  name,
							  parent,
							  isexpired,
}) => (
	{
		id: id,
		name: name,
		parent: parent,
		recovery: recovery,
		main: !!main,
		isexpired:isexpired,
	}
);